/**
 * 교재 data-id 위치 맵핑 디코더
 *
 * data-id(예: "beg1-l1-pep-ex3")를 교재 맵핑으로 디코딩해 사람이 읽는
 * 위치명 배열(breadcrumb)을 반환한다.
 *
 * 맵핑의 key 는 data-id 의 **하이픈 경계 구간(segment)** 이며, 한 토큰("pep")일 수도,
 * 여러 토큰 묶음("beg1-l1")일 수도 있다. depth 는 그 구간의 계층 순서다.
 *
 * 매칭 규칙: `-${dataId}-` 안에 `-${key}-` 가 포함되면 매칭 (하이픈 경계 검사로
 * "lis3" 이 "lis30" 에 오매칭되는 것을 방지). 매칭된 key 들을 depth → data-id 내 위치
 * 순으로 정렬해 value 들을 breadcrumb 로 만든다.
 *
 * @param {string} dataId   - 학습활동의 data-id (예: "beg1-l1-pep-ex3")
 * @param {Array<{depth:number, key:string, value:string}>} mappings - 해당 교재(barcode)의 맵핑 목록
 * @returns {string[]} 위치명 breadcrumb (depth 순). 매칭 없으면 빈 배열.
 */
export function decodeDataIdLocation(dataId, mappings) {
  if (!dataId || !Array.isArray(mappings) || mappings.length === 0) return [];

  const haystack = `-${dataId}-`;
  const token = (key) => `-${String(key).trim()}-`;

  const matched = mappings
    .filter((m) => m && m.key && haystack.includes(token(m.key)))
    .sort(
      (a, b) =>
        (a.depth - b.depth) ||
        (haystack.indexOf(token(a.key)) - haystack.indexOf(token(b.key)))
    );

  const seen = new Set();
  const crumbs = [];
  matched.forEach((m) => {
    if (m.value && !seen.has(m.value)) {
      seen.add(m.value);
      crumbs.push(m.value);
    }
  });
  return crumbs;
}
